module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=TG - Togo.d51a01c9.svg";